<ng-template #customLoadingTemplate>
    <div class="custom-class">
        <h4>Processing login...</h4>
    </div>
</ng-template>
<div class="container-loader" *ngIf="isBusy">
    <ngx-loading [show]="isBusy" [config]="loaderConfig" [template]="customLoadingTemplate"></ngx-loading>
</div>
